import { ChangeDetectorRef, Component, EventEmitter, Output, ViewContainerRef } from '@angular/core';
import { AngularComponentFactory } from 'survey-angular-ui';
import { PaymentFormTelecheckWidgetModel } from './payment-form-telecheck.widget.model';
import { RendererFactory } from 'survey-core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { PaymentFormTelecheckWidgetJson } from './payment-form-telecheck.widget.json';
import { PaymentTelecheckService } from '@tangilla/tg-ng-payments';
import { PaymentFormWidgetService } from '../services/payment-form.widget.service';
import { VariablesService } from '../../../../../core/services/survey/variables.service';
import { QuestionsService } from '../../../../../core/services/survey/questions.service';
import { StringUtils } from '@tangilla/tg-ng-common';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { SnackbarService } from '@tangilla/tg-ng-core';
import { TangillaQuestion } from '../../tangilla-question';

@Component({
  selector: 'tgf-payment-form-telecheck-widget',
  templateUrl: './payment-form-telecheck.widget.component.html',
  styleUrls: ['./payment-form-telecheck.widget.component.scss']
})
export class PaymentFormTelecheckWidgetComponent extends TangillaQuestion<PaymentFormTelecheckWidgetModel> {
  @Output() switchedToCreditCard = new EventEmitter<any>();

  totalCharge = this.variablesService.totalCharges;
  charges = this.variablesService.charges;
  isLoading = false;
  isLoadingPayment = false;

  paymentFormTelecheckWidgetJson = new PaymentFormTelecheckWidgetJson();

  questionJson: any;

  constructor(
    private paymentTelecheckService: PaymentTelecheckService,
    public paymentFormWidgetService: PaymentFormWidgetService,
    public variablesService: VariablesService,
    private snackbarService: SnackbarService,
    formBuilder: FormBuilder,
    surveyService: SurveyService,
    questionsService: QuestionsService,
    changeDetectorRef: ChangeDetectorRef,
    viewContainerRef?: ViewContainerRef
  ) {
    super(formBuilder, surveyService, questionsService, changeDetectorRef, viewContainerRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.scrollTopOnFormInvalid = true;
    this.initForm();
  }

  initForm() {
    this.usePersonAddress();
    this.addAddressFormControls();
    this.questionJson = this.paymentFormTelecheckWidgetJson.getWidgetJson(this.questionForm!);
    this.questionForm.valueChanges.subscribe(data => {
      this.changeDetectorRef.detectChanges();
    });
  }

  usePersonAddress() {

  }

  addAddressFormControls() {
    this.addAddressFormControl('terms_of_payment');

    this.addAddressFormControl('account_name');
    this.addAddressFormControl('check_number');
    this.addAddressFormControl('micr_number');

    this.addAddressFormControl('email_address');
    this.addAddressFormControl('drivers_license_number');
    this.addAddressFormControl('drivers_license_state');
    this.addAddressFormControl('date_of_birth');
  }

  addAddressFormControl(controlName: string, validators = [Validators.required]) {
    this.questionForm.addControl(controlName, new FormControl(null, validators));
  }

  makePayment() {
    const that = this;
    this.submitForm(() => that.doMakePayment());
  }

  async doMakePayment() {
    if (this.surveyService.isPreview) {
      this.snackbarService.error('No payments allowed in preview mode');
      this.changeDetectorRef.detectChanges();
      return;
    }
    await this.processPayment();
  }

  async processPayment() {
    this.isLoadingPayment = true;
    this.paymentFormWidgetService.paymentErrorMessage = undefined;
    this.changeDetectorRef.detectChanges();

    const body = this.formToEntity();

    const paymentPayload = this.paymentFormWidgetService.getPaymentPayload([this.charges], 'check');
    const payloadToMakePayment = {
      ...paymentPayload,
      ...this.paymentTelecheckService.getPaymentCheckFields()
    };

    try {
      await this.paymentFormWidgetService.doMakePayment(body, payloadToMakePayment, this.charges.billing_year, 'check', this.charges.create_cco_record);
    } catch (error: any) {
    } finally {
      this.isLoadingPayment = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  formToEntity() {
    const formBody = this.questionForm.getRawValue();
    return {
      addressLine1: formBody.addressLine1,
      state: formBody.state,
      city: formBody.city,
      zip: formBody.zip5,
      dateOfBirth: formBody.date_of_birth,
      emailAddress: formBody.email_address,
      driverLicenseNumber: formBody.drivers_license_number,
      driverLicenseState: formBody.drivers_license_state,
      accountName: formBody.account_name,
      checkNumber: formBody.check_number,
      micrNumber: formBody.micr_number,
    };
  }

  getAddressFormModel() {
    const model = {
      jsonObj: {
        showTitle: false,
        namesReplacements: {
          addressLine1: 'ecaddress1',
          addressLine2: '',
          state: 'ecstate',
          city: 'eccity',
          zip5: 'eczip'
        },
        labelsReplacements: {
          addressLine1: 'Address',
          addressLine2: '',
          state: 'State',
          city: 'City',
          zip5: 'Zip'
        },
        defaultValueQuestionNames: {
          addressLine1: 'h_address1',
          state: 'h_state',
          city: 'h_city',
          zip5: 'h_zip'
        },
        includeInOutputFields: {
          addressLine1: false,
          addressLine2: false,
          state: false,
          city: false,
          zip5: false
        },
        excludeFields: [
          'addressLine2',
        ],
      }
    };
    return model as any;
  }

  getPersonFullName() {
    return `${this.questionsService.firstName?.value} ${this.questionsService.lastName?.value}`;
  }

  switchToCreditCard() {
    this.switchedToCreditCard.emit();
  }

  isItLoading() {
    return this.isLoading || this.isLoadingPayment;
  }

  protected readonly StringUtils = StringUtils;
}

RendererFactory.Instance.registerRenderer(
  'payment_form_telecheck',
  'payment_form_telecheck',
  'tg_payment_form_telecheck',
  true
);
AngularComponentFactory.Instance.registerComponent('tg_payment_form_telecheck', PaymentFormTelecheckWidgetComponent);
